/* To implements tabs :
 * Give "tabs" as id for the global tabs container
 * Add the class "category-tabs" to the list of tabs titles (usaually a <ul>)
 */
(function ($) {
    $(window).load(function () {
		jQuery(document).ready(function($) {
			//if (window.innerWidth > 980) {
				$("#tabs").tabs();
			// }
		});
    });
})(jQuery);
